import { render } from "./IframeBlock.vue?vue&type=template&id=7940b11c&scoped=true"
import script from "./IframeBlock.vue?vue&type=script&lang=js"
export * from "./IframeBlock.vue?vue&type=script&lang=js"

import "./IframeBlock.vue?vue&type=style&index=0&id=7940b11c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7940b11c"],['__file',"src/vue/components/IframeBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7940b11c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7940b11c', __exports__)) {
    api.reload('7940b11c', __exports__)
  }
  
  module.hot.accept("./IframeBlock.vue?vue&type=template&id=7940b11c&scoped=true", () => {
    api.rerender('7940b11c', render)
  })

}


export default __exports__